<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
 
    mounted() {
      
   }
  
}
</script>

<style lang="less">
input,
div,
i,
a,
span,
button,
textarea {
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica", "Cuntery Gothic","Arial" !important;
}
#app{
  background-color: #fff;
}
</style>
